import { render, staticRenderFns } from "./stockpackstatistical-list.vue?vue&type=template&id=5b702d50&scoped=true"
import script from "./stockpackstatistical-list.vue?vue&type=script&lang=ts"
export * from "./stockpackstatistical-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b702d50",
  null
  
)

export default component.exports